export const defaults = {
  tenantCollectionSlug: 'tenants',
  tenantFieldName: 'tenant',
  tenantsArrayFieldName: 'tenants',
  tenantsArrayTenantFieldName: 'tenant',
  tenantSelectorLabel: 'Tenant',
}
